import { CLIENT_ID_LOGIN, CLIENT_STATE_LOGIN } from '../../../hooks/constants';

export type { ActionsModel, InitialStateModel } from './types';

export const loginRedirection =()=>{
  const baseUrl = process.env.REACT_APP_BACKEND_URL
  // Only the special-offer page needs its query string (e.g. ?image=34) preserved;
  // every other route keeps the original pathname-only behavior.
  const redirection = window.location.pathname.startsWith('/sonderangebot')
    ? window.location.pathname + window.location.search
    : window.location.pathname;
  localStorage.setItem('login_redirection', redirection);
  window.location.href=`https://id.${baseUrl?.includes('stage')?'stage.':''}bluemovie.com/bm/ident/auth?client_id=${CLIENT_ID_LOGIN}&redirect_uri=https://${baseUrl?.includes('stage')?'stage.':''}bluemovie.com/loginresponse&response_type=code&state=${CLIENT_STATE_LOGIN}&country=DE#/`;
}
